import { Link } from 'react-router-dom';
import { Carrot, Apple, Milk, ShoppingBasket, Cookie, Home, Coffee, Heart, Wheat, Sparkles } from 'lucide-react';

const iconMap = {
  Carrot,
  Apple,
  Milk,
  ShoppingBasket,
  Cookie,
  Home,
  Coffee,
  Heart,
  Wheat,
  Sparkles,
};

export function CategoryCard({ category }) {
  const IconComponent = iconMap[category.icon] || ShoppingBasket;

  return (
    <Link
      to={`/products/${category.slug}`}
      className="flex flex-col items-center gap-2 p-2 cursor-pointer hover:opacity-80 transition-opacity category-card"
      data-testid={`category-${category.slug}`}
    >
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary/10 border-2 border-primary/20 flex items-center justify-center shadow-sm">
        <IconComponent className="w-10 h-10 md:w-12 md:h-12 text-primary" strokeWidth={2.2} />
      </div>
      <span className="text-sm md:text-base font-semibold text-center line-clamp-2 leading-tight">
        {category.name}
      </span>
    </Link>
  );
}
